import { render } from "./RuleAction.vue?vue&type=template&id=34085591&scoped=true"
import script from "./RuleAction.vue?vue&type=script&lang=js"
export * from "./RuleAction.vue?vue&type=script&lang=js"

import "./RuleAction.vue?vue&type=style&index=0&id=34085591&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34085591"]])

export default __exports__